<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps<{
    state?: "active" | "complete";
    step?: number;
    icon?: string;
    label: string;
}>();

// Define a computed property to handle the dynamic classes
const stateClasses = computed(() => {
    switch (props.state) {
        case "active":
            return "bg-slate-900 border-slate-500 text-white";
        case "complete":
            return "bg-green-100 border-green-700 text-green-700";
        default:
            return "bg-gray-50 border-gray-200 text-black";
    }
});

// Define a computed property for the step circle's background color
const stepCircleClasses = computed(() => {
    switch (props.state) {
        case "active":
            return "bg-white text-slate-900";
        case "complete":
            return "bg-green-700 text-white";
        default:
            return "bg-gray-500 text-white";
    }
});
</script>
<template>
    <div
        class="flex flex-1 justify-center gap-2 px-6 py-3 bg-gray-50 border-b-4 border-gray-200 text-sm font-semibold items-center"
        :class="stateClasses"
        :aria-hidden="!(state === 'active' || state === 'complete')"
    >
        <div
            v-if="step || icon"
            class="rounded-full w-5 h-5 flex items-center justify-center text-2xs"
            :class="stepCircleClasses"
        >
            <span v-if="step">
                {{ step }}
            </span>
            <svg-icon
                v-if="icon"
                :icon="icon"
                size="xs"
                weight="bold"
                aria-hidden="true"
            ></svg-icon>
        </div>
        <p>{{ label }}</p>
    </div>
</template>
